import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';

import { ProcessService } from 'src/app/service/process.service';
import { PagingContainerModel } from 'src/app/model/paging-container.model';
import { ProcessSummaryModel } from 'src/app/model/process-summary.model';
import { PagingModel } from 'src/app/model/paging.model';
import swal from 'sweetalert2';
import { AuthenticationService } from 'src/app/service/auth.service';
import { AnalyticsModel } from 'src/app/model/analytics.model';
import { AnalyticsService } from 'src/app/service/analytics.service';
import { WorkflowGatewayService } from 'src/app/service/workflow-gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { SearchParamsModel } from 'src/app/model/search-params.model';
import { takeUntil, takeWhile } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NotificationService } from 'src/app/service/notification.service';
import { NavigationService } from 'src/app/service/navigation.service';
import { BackdropService } from 'src/app/service/backdrop.service';
import { AttributeModel } from '../dynamic/model/attribute.model';
import { NotificationSharedService } from 'src/app/service/notification-shared.service';
import { InstanceService } from 'src/app/service/instance.service';
import { ProcessModel } from 'src/app/model/process.model';
import { InstanceModel } from 'src/app/model/instance.model';
import { MaskApplierService } from 'ngx-mask';
import { GatewayConnectorsService } from 'src/app/service/gateway-connectors.service';
import { CurrencyService } from 'src/app/service/currency.service';
import { DesignService } from 'src/app/service/design.service';
import { OptionModel } from '../dynamic/model/option.model';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss',],
})
export class DashboardComponent implements OnInit, OnDestroy {

  private interval;
  private countInterval;
  private isLoading = false;
  isCountLoading = false;
  showPopup = false;

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 700,
    nav: false,
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      }
    },
  }

  startPage: number = 1;
  currentPage: number = 1;
  totalPage: number;
  totalItems: number = 0;
  throttle = 300;
  scrollDistance = 1;
  scrollUpDistance = 2;
  pagingModel: PagingModel
  processes: ProcessSummaryModel[] = []
  subsCounter: number = 0
  analytics: AnalyticsModel[] = []
  searchParams: SearchParamsModel = new SearchParamsModel();
  isChangingPage: boolean = false;
  unsubscribe = new Subject<any>();
  showModalPrint: boolean;
  printProcessId: string;
  itemsAttr: AttributeModel[];
  selectedPrintItems: string[];
  sellsAmmount: number = 0;
  sellerLimit: number = 0;
  purchasesAmmount: number = 0;
  customerLimit: number = 0;
  customerPotentialLimit: number = 0;
  agendaCerc: AgendaCerc = {
    totalValorLivre: 0,
    agenda: [
      {
        period: "-",
        totalValorLivre: 0
      }
    ]
  };

  // Atributos do Start Menu (cacheados para evitar recriação em cada detecção de mudanças)
  startMenuAttrs: AttributeModel[] = [];
  // envOptions estáveis para os componentes dinâmicos
  readonly envOptions: OptionModel[] = [
    { key: 'viewmode', value: 'View', type: 'Text' }
  ];

  constructor(
    private router: Router,
    private processService: ProcessService,
    private analyticsService: AnalyticsService,
    private workflowService: WorkflowGatewayService,
    private authService: AuthenticationService,
    private spinner: NgxSpinnerService,
    private notifications: NotificationService,
    private navigationService: NavigationService,
    private backdrop: BackdropService,
    private notificationService: NotificationSharedService,
    private instanceService: InstanceService,
    private maskService: MaskApplierService,
    private gatewayConnectors: GatewayConnectorsService,
    private currencyService: CurrencyService,
    private designService: DesignService
    ) { }


  get customerLimitFormated(): string {
    const currencyMask = this.currencyService.getCurrencyMaskText(`${this.customerLimit}`);
    return this.maskService.applyMask(`${this.customerLimit}`, currencyMask);
  }

  get customerAmmountFormated(): string {
    const currencyMask = this.currencyService.getCurrencyMaskText(`${this.purchasesAmmount}`);
    return this.maskService.applyMask(`${this.purchasesAmmount}`, currencyMask);
  }

  get customerPotentialLimitFormated(): string {
    const currencyMask = this.currencyService.getCurrencyMaskText(`${this.customerPotentialLimit}`);
    return this.maskService.applyMask(`${this.customerPotentialLimit}`, currencyMask);
  }

  get customerUsagePercent(): number {
    if(this.customerLimit > 0) {
      return (this.purchasesAmmount / this.customerLimit) * 100;
    }

    return 0
  }

  get customerPotentialUsagePercent(): number {
    if(this.customerPotentialLimit > 0) {
      return (this.purchasesAmmount / this.customerPotentialLimit) * 100;
    }

    return 0
  }

  get isNewVersion(): boolean {
    return this.authService.getFrontendVersion() == "v2"
  }

  get isCustomer(): boolean {
    return this.authService.hasRole("Comprador");
  }

  get isSeller(): boolean {
    return this.authService.hasRole("Vendedor");
  }

  get sellerLimitFormated(): string {
    const currencyMask = this.currencyService.getCurrencyMaskText(`${this.sellerLimit}`);
    return this.maskService.applyMask(`${this.sellerLimit}`, currencyMask);
  }

  get sellsAmmountFormated(): string {
    const currencyMask = this.currencyService.getCurrencyMaskText(`${this.sellsAmmount}`);
    return this.maskService.applyMask(`${this.sellsAmmount}`, currencyMask);
  }

  get storagePage(): number {
    return localStorage.getItem("dashPageNumber")
      ? +localStorage.getItem("dashPageNumber") : 1
  }

  get sellerUsagePercent(): number {
    if(this.sellerLimit > 0) {
      return (this.sellsAmmount / this.sellerLimit) * 100;
    }

    return 0
  }

  get metabaseAttribute(): AttributeModel {
    const startMenu = this.designService.getStartMenu();

    if (startMenu) {
      const metabaseFrame = startMenu.attributes
        .find(attr => attr.type.toLowerCase() == "MetabaseFrame".toLowerCase());

      return metabaseFrame;
    }

    return null;
  }

  get startMenuAttributes(): AttributeModel[] {
    const startMenu = this.designService.getStartMenu();

    if (startMenu && startMenu.attributes) {
      return startMenu.attributes
        .filter(attr => attr.type && attr.type.toLowerCase() !== 'metabaseframe');
    }

    return [];
  }

  getEnvOptions(): OptionModel[] {
    return [
      {
        key: 'viewmode',
        value: 'View',
        type: 'Text'
      }
    ];
  }

  @HostListener('window:beforeunload', ['$event'])
  registerPageLeaving($event) {
    this.registerNavigation("LeavePage")
    if (!(window as any).__intentionalRedirect) {
      $event.preventDefault();
    }
  }

  ngOnInit() {
    this.registerNavigation("EnterPage")
    this.firstLoad()
    // Inicializa atributos do Start Menu uma única vez (evita recriações)
    this.initStartMenuAttributes();
    this.interval = setInterval(() => {
      if(!this.isLoading) {
        this.loadProcesses(this.storagePage, false)
      }
    }, 5000);
    this.countInterval = setInterval(() => {
      if(!this.isCountLoading) {
        this.loadCount()
      }
    }, 30000);
  }

  private registerNavigation(actionName: string) {
    if(this.authService.isAuthenticated()) {
      this.navigationService
        .create({ action: actionName, url: location.href })
        .subscribe(
          () => console.log("navigation registered"),
          ()=> console.log("error on registering navigation"))
    }
  }

  private verifyNotifications() {
    this.notifications.get().subscribe((data: any) => {
      if(data.hasNotification) {
        this.loadProcesses(1, false)
      }
    })
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
    clearInterval(this.countInterval);
    this.registerNavigation("LeavePage")
  }

  doSearch() {
    this.loadProcesses();
  }

  getTextPendingTasks(numberOfPendings: number): string {
    if(numberOfPendings > 1) {
      return "tarefas pendentes."
    } else if(numberOfPendings == 1) {
      return "tarefa pendente."
    } else {
      return ""
    }
  }

  getUserName(): string {
    let user = this.authService.getUser();
  
    if (user && user.name) {
      let names = user.name.split(' ');
  
      return names.slice(0, 2).join(' ');
    }
  
    return '';
  }
  
  firstLoad(showloading: boolean = true){
    this.loadProcesses(this.storagePage, showloading)
    this.loadCount()

    if (this.isSeller) {
      this.loadDashboardSeller();
    }

    if(this.isCustomer) {
      this.loadDashboardCustomer();
    }

    this.loadAnalytics()
    this.processService.resetModel()
  }

  private initStartMenuAttributes(): void {
    const startMenu = this.designService.getStartMenu();

    if (startMenu && startMenu.attributes) {
      this.startMenuAttrs = startMenu.attributes
        .filter(attr => attr.type && attr.type.toLowerCase() !== 'metabaseframe');
    } else {
      this.startMenuAttrs = [];
    }
  }

  trackByAttr(index: number, attr: AttributeModel): string {
    const key = (attr && attr.key) ? attr.key : index.toString();
    const type = (attr && attr.type) ? attr.type : 'unknown';
    return `${key}__${type}`;
  }

  private loadDashboardCustomer() {
    const user = this.authService.getUser();

    if(user && user.defaultProcessId) {
      this.instanceService
        .getByIdFull(user.defaultProcessId)
        .subscribe((composition: ProcessModel) => {
          const cnpj = this.findDocumento(composition.instance);
          const limit = this.findField(composition.instance, "limite");
          const portentialLimit = this.findField(composition.instance, "limite potencial");

          if(limit) {
            this.customerLimit = this.currencyService
              .getCurrencyStringNoSeparatorNumber(limit.value);
          }

          if(portentialLimit && portentialLimit.value) {
            this.customerPotentialLimit = this.currencyService
              .getCurrencyStringNoSeparatorNumber(portentialLimit.value);
          }

          this.gatewayConnectors
            .getWithComplement(`Cerc/Agenda?cnpj=${cnpj}`)
            .subscribe((agenda: AgendaCerc) => {
              this.agendaCerc = agenda;
            })
        });
    }

    this.workflowService
      .getSummary(1, 50, {
        searchParams: {
          filter: [ "Summary" ],
          isActive: true,
          policyId: "65dca071383b2ba0f2cce273"
        }
      })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((pagingContainer: PagingContainerModel) => {
        const purchases = pagingContainer.items;

        purchases.forEach(purchase => {
          if(purchase.attributes[1].value) {
            this.purchasesAmmount += this.currencyService.getCurrencyStringNoSeparatorNumber(purchase.attributes[1].value);
          }
        })
      }, (error)=> this.handleHttpError(error))
  }

  private findDocumento(instance: InstanceModel) {
    const section = instance.attributes.find(attr => attr.type.toLowerCase() == "section");
    const companyAttr = section.attributes.find(attr => attr.type.toLowerCase() == "company");

    if(companyAttr) {
      const documento = companyAttr.attributes.find(attr => attr.key.toLowerCase() == "documento");

      if(documento) {
        return documento.value;
      }
    }

    return ""
  }

  private loadDashboardSeller() {

    const user = this.authService.getUser();

    if(user && user.defaultProcessId) {
      this.instanceService
        .getByIdFull(user.defaultProcessId)
        .subscribe((composition: ProcessModel) => {
          const limit = this.findField(composition.instance, "limite");
          this.sellerLimit = this.currencyService
            .getCurrencyStringNoSeparatorNumber(limit.value);
        });
    }

    this.workflowService
      .getSummary(1, 50, {
        searchParams: {
          filter: [ "Summary" ],
          isActive: true,
          policyId: "65dca071383b2ba0f2cce273"
        }
      })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((pagingContainer: PagingContainerModel) => {
        const sells = pagingContainer.items;

        sells.forEach(sell => {
          if(sell.attributes[1].value) {
            this.sellsAmmount += this.currencyService.getCurrencyStringNoSeparatorNumber(sell.attributes[1].value);
          }
        })
      }, (error)=> this.handleHttpError(error))
  }

  private findField(instanceModel: InstanceModel, fieldName: string): AttributeModel {
    const section = instanceModel.attributes.find(attr => attr.type.toLowerCase() == "section");
    if(section) {
      const limit = section.attributes.find(attr => attr.key.toLowerCase() == fieldName.toLowerCase());

      if(limit) {
        return limit;
      } else if(instanceModel.nextStep) {
        return this.findField(instanceModel.nextStep, fieldName);
      } else {
        return null;
      }
    } else if(instanceModel.nextStep) {
      return this.findField(instanceModel.nextStep, fieldName);
    } else {
      return null
    }
  }

  onScrollDown() {
    if (this.currentPage < this.totalPage) {
      this.currentPage = this.currentPage + 1;
      this.mudarPagina(this.currentPage);
    }
  }

  onUp() {

  }

  onRunningTask(){
    this.isLoading = true
  }

  loadProcesses(pagina?: number, showLoading: boolean = true): any {
    if (showLoading) {
      this.spinner.show();
    }

    if (!pagina && localStorage.getItem("dashPageNumber")) {
      pagina = +localStorage.getItem("dashPageNumber");
    }

    if (sessionStorage.getItem("searchParams_start")) {
      this.searchParams = JSON.parse(sessionStorage.getItem("searchParams_start"));
    }

    this.searchParams.orderDesc = true;

    let user = this.authService.getUser();

    if(!user) {
      return;
    }

    this.isLoading = true;

    const dashSearchParams = {
      filterName: "SummaryDashboard",
      currentStepUserId: user.id,
      orderDesc: true,
      isActive: true,
      attributes: this.searchParams.attributes
    };

    this.workflowService
      .getSummary(pagina, 10, { searchParams: dashSearchParams })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((pagingContainer: PagingContainerModel) => {
        if(this.isChangingPage){
          this.unsubscribe.next()
          this.isChangingPage = false
        }else{
          this.processes = pagingContainer.items;
          this.pagingModel = pagingContainer.paging;
          this.spinner.hide();
          this.isLoading = false
        }
        if(pagingContainer.items.length == 0 && pagina > 1){
          this.mudarPagina(pagina -1, false)
        }
        this.isLoading = false
      }, (error)=> this.handleHttpError(error))
  }

  private loadCount(): void {
    const user = this.authService.getUser();
    if (!user) { return; }

    const dashSearchParams = {
      filterName: "SummaryDashboard",
      currentStepUserId: user.id,
      orderDesc: true,
      isActive: true,
      attributes: this.searchParams.attributes
    };

    this.isCountLoading = true;

    this.workflowService
      .getCount(10, { searchParams: dashSearchParams })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        countResult => {
          this.totalItems = countResult.totalItems;
          this.totalPage = countResult.totalPages;
          this.notificationService.setItemCount(this.totalItems);
          this.isCountLoading = false;
        },
        () => {
          this.isCountLoading = false;
        }
      );
  }

  private loadAnalytics() {
    // this.analyticsService
    //   .get().subscribe(
    //     (model) => this.analytics = model,
    //     (error)=> this.handleHttpError(error))
  }

  getOuterColorByItem(item: AnalyticsModel) {
    if(!item.color) {
      return "#028ada"
    }

    switch (item.color.toLowerCase()) {
      case "blue":
        return "#028ada";
      case "green":
        return "#038803";
      case "yellow":
        return "#ffb700";
      case "red":
        return "#d42605";
      default:
        return "#028ada";
    }
  }

  getInnerColorByItem(item: AnalyticsModel) {
    if(!item.color) {
      return "#028ada"
    }

    switch (item.color.toLowerCase()) {
      case "blue":
        return "#b0dffa";
      case "green":
        return "#c2e4c2";
      case "yellow":
        return "#fae5aa";
      case "red":
        return "#f4bfb1";
      default:
        return "#b0dffa";
    }
  }

  getPercentByGroupName(...names: string[]): string {
    let percent = 0

    names.forEach(name => {
      let data = this.analytics.find(a => a.groupName == name)

      if(data) {
        percent += +parseFloat(data.percent.toString().replace(',', '.'))
      }
    })

    return percent.toString()
  }

  mudarPagina(pageNumber: number, showLoading: boolean = true): void {
    this.isChangingPage = true;
    this.currentPage = pageNumber;
    localStorage.setItem("dashPageNumber", pageNumber.toString());
    this.loadProcesses(pageNumber, showLoading);
  }

  countPage() {
    return this.totalPage ?? 0;
  }

  obterPaginas(): number[] {
    const maxPages = 20;
    const pageNumbers: number[] = [];
    if (this.totalPage > 0) {
      const startPage = Math.max(1, Math.ceil(this.currentPage / maxPages) * maxPages - maxPages + 1);
      const endPage = Math.min(this.totalPage, startPage + maxPages - 1);
      for (let page = startPage; page <= endPage; page++) {
        pageNumbers.push(page);
      }
    }
    return pageNumbers;
  }
  
  firstPages(): void {
    this.mudarPagina(1);
  }
  
  lastPages(): void {
    this.mudarPagina(this.totalPage);
  }
  
  previousPages(): void {
    const previousSetStart = Math.max(1, this.currentPage - 20);
    this.mudarPagina(previousSetStart);
  }
  
  nextPages(): void {
    const nextSetStart = Math.min(this.totalPage, this.currentPage + 20);
    this.mudarPagina(nextSetStart);
  }

  isActive(numero: number) {
    return (numero == this.pagingModel.pageNumber)
  }

  existPending(): boolean {
    if (this.processes.length > 0) {
      return true;
    }
    else
      return false;
  }

  // events
  public chartClicked(e: any): void {
    console.log(e);
  }

  public chartHovered(e: any): void {
    console.log(e);
  }

  togglePopup(): void {
    this.showPopup = !this.showPopup;
  }

  updateList() {
    this.isLoading  = false
    this.loadProcesses(this.storagePage)
  }

  private handleHttpError(error: any) {
    this.spinner.hide();
    this.isLoading = false

    if(error.status == 401) {
      this.authService.logout()
      this.router.navigate(['login']);
    } else if(error.status == 403) {
      swal.fire("Atenção", "Este usuário não tem  para acessar este conteúdo.")
        .then(() => this.router.navigate([""]).then(() => swal.close()))
    } else if(error.message) {
      swal.fire("Atenção", error.message, "error").then(() => {
        if(error.goBackToHome) {
          this.router.navigate([""]).then(() => swal.close())
        }
      })
    } else {
      swal.fire("Atenção", "Algo errado aconteceu; Por favor, tente novamente.", "error")
    }
  }

  onValueChange(value: any) {
    if(value.target.checked)
      this.selectedPrintItems.push(value.target.value);
    else{
    var indexRemove = this.selectedPrintItems.indexOf(value.target.value);
    this.selectedPrintItems.splice(indexRemove,1);
    }
  }

  sendPrint(){
    if(this.selectedPrintItems.length <1) {
     swal.fire({
       title: 'Atenção',
       text: "Favor selecionar um item para impressão.",
       icon: 'error',
       showCancelButton: false,
       confirmButtonColor: '#3085d6',
       confirmButtonText: 'Fechar'
     });
   } else {
     window.open("/print?processId="+this.printProcessId+"&procedimentos="+this.selectedPrintItems.toString(),"_blank");
     this.toggleModalPrint();
   }
 }

 toggleModalPrint(processId: string = null) {
   if(processId) {
     this.printProcessId = processId;
     let processList = this.processes
                           .find(p => p.id == processId);

     this.itemsAttr = processList.attributes
                            .find(attr =>attr.type.toLowerCase() == "items")
                            .attributes;
     this.selectedPrintItems = this.itemsAttr.map(i=>i.attributes[1].value);
   }

   this.showModalPrint = !this.showModalPrint;

   if(this.showModalPrint)
     this.backdrop.show();
   else
     this.backdrop.hide();
 }
}